import { useViewport } from '../../hooks/useViewport';

import ClientDealDepositFields from './ClientDealDepositFields';
import ClientDealPeople from './ClientDealPeople';
import { COLUMN } from './steps/step-layout';
import TextField from './TextField';
import type { ClientDealForm as Form } from './use-client-deal-form';

export default function ClientDealForm({ form }: { form: Form }) {
  const { draft, set, fieldError } = form;
  const { isPhone } = useViewport();
  const two = { display: 'grid', gridTemplateColumns: isPhone ? '1fr' : '1fr 1fr', gap: 10 };
  return (
    <div style={COLUMN}>
      <TextField
        label="Client name"
        required
        value={draft.clientName}
        onChange={(v) => set('clientName', v)}
        error={fieldError('clientName')}
      />
      <div style={two}>
        <TextField
          label="Point of contact"
          value={draft.contactName}
          onChange={(v) => set('contactName', v)}
          error={fieldError('contactName')}
        />
        <TextField
          label="Phone"
          type="tel"
          value={draft.contactPhone}
          onChange={(v) => set('contactPhone', v)}
          error={fieldError('contactPhone')}
        />
      </div>
      <TextField
        label="Email"
        type="email"
        value={draft.contactEmail}
        onChange={(v) => set('contactEmail', v)}
        error={fieldError('contactEmail')}
      />
      <ClientDealPeople draft={draft} set={set} fieldError={fieldError} />
      <div style={two}>
        <TextField
          label="Deal value"
          hint="reference only"
          prefix="≈ $"
          inputMode="decimal"
          value={draft.dealValue}
          onChange={(v) => set('dealValue', v)}
          error={fieldError('dealValueCents')}
          maxWidth={140}
        />
        <TextField
          label="HubSpot deal"
          hint="paste the deal ID or URL"
          value={draft.hubspotDealId}
          onChange={(v) => set('hubspotDealId', v)}
          error={fieldError('hubspotDealId')}
          maxWidth={220}
        />
      </div>
      <ClientDealDepositFields form={form} />
    </div>
  );
}
